// extracted by mini-css-extract-plugin
export var dropdownIcon = "_q8-6";
export var imgContainer = "_q8-3";
export var menuIcon = "_q8-5";
export var pillWrapper = "_q8-2";
export var pillsContainer = "_q8-1";
export var subscriptionCard = "_q8-0";
export var subscriptionLogo = "_q8-4";